import React, {
    useContext,
} from 'react';
import { useMutation } from '@tanstack/react-query';
import Cookies from "js-cookie";

import { NotificationContext, handleError } from "../router"

import * as QUERIES from "../query-functions";
import SpektrixSession from '../../scripts/components/SpektrixSession';

export default function LogoutButton() {

    const {notification, setNotification} = useContext(NotificationContext);
    const session = new SpektrixSession();

    const logOut = useMutation({
        mutationFn: () => QUERIES.logOut(),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            session.updateSession(null, true, true);
            window.location.reload();
        },
    })

    return (
        <button type="button" className='btn btn--logout' onClick={() => logOut.mutateAsync()}>Logout</button>
    );
}
